import { CHART_PERCENT_PRECISION } from "@/constants/Charts";

export const tooltipFormatter = ({ name, value, percent }) => {
  const percentString = percent ? ` (${percent}%)` : "";
  return `<strong>${name}</strong><br />${value}${percentString}`;
};

export const getDonutDataTotal = (data = []) => {
  return (data ?? []).reduce((sum, entry) => {
    const value = typeof entry.value === "number" ? entry.value : 0;
    return sum + value;
  }, 0);
};

export const getDonutDataValue = (data = [], name = "") => {
  return data?.find((entry) => entry.name === name)?.value;
};

export const getValuePercent = (value, total) => {
  if (!value || !total) return 0;
  return parseFloat(((value / total) * 100).toFixed(CHART_PERCENT_PRECISION));
};
